// extracted by mini-css-extract-plugin
module.exports = {"more":"More_style_more__7nGfd","text":"More_style_text__3ZV6N"};